export default "__VITE_ASSET__BpkyCySD__"